<script setup lang="ts">
const CTA_STICKY_ELEMENT_BLACKLIST = ['/apply']

const route = useRoute()
const showCTAStickyElement = computed(() => {
  return !CTA_STICKY_ELEMENT_BLACKLIST.some(
    (blacklistedPath) =>
      route.path === blacklistedPath ||
      route.path.startsWith(`${blacklistedPath}/`)
  )
})
</script>

<template>
  <main>
    <slot />

    <LazyBaseCTAStickyElement v-if="showCTAStickyElement" position="bottom" />
  </main>
</template>
